var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiInsightsGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140920",
    "data-name": "Rectangle 140920",
    width: 20,
    height: 20,
    rx: 5,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Active",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48287",
    "data-name": "Path 48287",
    d: "M15.416,20H4.584A4.584,4.584,0,0,1,0,15.416V4.584A4.584,4.584,0,0,1,4.584,0H15.416A4.584,4.584,0,0,1,20,4.584V15.416A4.584,4.584,0,0,1,15.416,20",
    transform: "translate(0 0)",
    fill: "#1c9f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48288",
    "data-name": "Path 48288",
    d: "M4.53,13.113H2.392L5.65,3.675H8.222l3.253,9.438H9.337L6.973,5.831H6.9ZM4.4,9.4h5.05V10.96H4.4Z",
    transform: "translate(0.584 1.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140919",
    "data-name": "Rectangle 140919",
    width: 1.995,
    height: 9.438,
    transform: "translate(13.193 5.281)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiInsightsGreen);
export default __webpack_public_path__ + "static/media/AI_Insights_green.44ad762b23df04e99df3027913251729.svg";
export { ForwardRef as ReactComponent };